var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-index',{ref:"baseIndex",attrs:{"columns":_vm.columns,"resourceName":_vm.resourceName,"pk":_vm.pk,"disabledFilterButton":false,"disabledAddButton":true,"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"render.status",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(" "+_vm._s(_vm.statusName(item.status))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }